"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tile = _interopRequireDefault(require("../../../Tile"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/no-danger */
var SuggestionsList = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var activeSuggestionIndex = _ref.activeSuggestionIndex,
      filteredSuggestions = _ref.filteredSuggestions,
      handleSuggestionOnClick = _ref.handleSuggestionOnClick,
      size = _ref.size;
  var firstListItemRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(_Tile.default, {
    classes: "dropdown-menu__card dropdown-menu__card--full-width suggestions",
    ref: ref,
    isPadded: false
  }, /*#__PURE__*/_react.default.createElement("ul", {
    role: "listbox",
    "aria-label": "Search suggestions",
    id: "listBoxId",
    className: "suggestions__list",
    "data-testid": "suggestionsList"
  }, filteredSuggestions.map(function (suggestion, index) {
    var listItemClasses = (0, _classnames.default)('cta', 'cta--text-alternate', 'cta--full-width', 'suggestions__item', {
      'cta--large': size === 'large',
      'cta--medium': size === 'small',
      'suggestions__item--active': index === activeSuggestionIndex
    });
    return (
      /*#__PURE__*/
      // NOTE: onMouseDown preventDefault is needed so that the click event on the suggestion item gets called before the blur event on the input, otherwise the click event only blurs the input and a second click event is required to fire the handleSuggestionOnClick event. - MR
      _react.default.createElement("li", {
        className: listItemClasses,
        key: suggestion,
        onClick: handleSuggestionOnClick,
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        role: "option",
        "aria-posinset": index + 1,
        "aria-setsize": filteredSuggestions.length,
        "aria-selected": index === activeSuggestionIndex,
        onKeyDown: handleSuggestionOnClick,
        tabIndex: "-1",
        ref: index === 0 ? firstListItemRef : null
      }, suggestion)
    );
  })));
});
SuggestionsList.propTypes = {
  /**
   Passes the active suggestion index.
   */
  activeSuggestionIndex: _propTypes.default.number.isRequired,

  /**
   Filtered list of suggestions to be passed in.
   */
  filteredSuggestions: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /**
   OnClick function for selecting the suggestion.
   */
  handleSuggestionOnClick: _propTypes.default.func.isRequired,

  /**
   Optional. Controls the size of the list items. Gets passed in from the InputField component. Defaults to 'large'.
   */
  size: _propTypes.default.string
};
SuggestionsList.displayName = 'SuggestionsList';
SuggestionsList.defaultProps = {
  size: 'large'
};
var _default = SuggestionsList;
exports.default = _default;